// extracted by mini-css-extract-plugin
export default {"patientAlertsActionButton":"PatientAlertsBanner_patientAlertsActionButton__K8lUg"};